import type { FaireProductEntity } from "../../entity_types/product";

export const p_rrayjfdn6c: FaireProductEntity = {
  token: "p_rrayjfdn6c",
  type: "product",
  name: "Aria Houndstooth Lapel Collar Blazer",
  brandToken: "b_aikxxfpecb",
  brandName: "Threaded Pear",
  imageUrl:
    "https://cdn.faire.com/fastly/e68212f53d442a3abc2b4010e13626cdc8c6a4f4d85984d21396c88f4f4b89ce.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/57a2b21220b15ee8daca13341b0d6dbce76bc6a31dc2d9220f04ea7dd0a43ee4.jpeg",
    "https://cdn.faire.com/fastly/75eb47e2f64526e9cb8b0d9ab1492594b6a30ef687b9c352840de62459eac509.jpeg",
    "https://cdn.faire.com/fastly/56d806736446b2d96aa3fbd2e332850a95db0df36e8158bd351ec23afca23d00.jpeg",
    "https://cdn.faire.com/fastly/d93aeb672c16a0343b3e38dbed8bc24f97307d8a68dcf5b74d40da03ae75bbc7.jpeg",
    "https://cdn.faire.com/fastly/25ef163a7c8f58c297f82b601277be5698aff1a9e9a77043d2f3bc139c6b9c75.jpeg",
    "https://cdn.faire.com/fastly/03dd3df1654299a7ce266a556df9a3d0102fca8f0804b926793eebd02b9c22b5.jpeg",
    "https://cdn.faire.com/fastly/de570b6d79f9b9bde8999e445fc2cdd0917860e803b04a06e3d91abf1e59563b.jpeg",
    "https://cdn.faire.com/fastly/c8b50cc18e5df6c3197191983c2290ac3c0ebe8a993562f8a96157b811dab056.jpeg",
    "https://cdn.faire.com/fastly/4e7ce25945f693e25e5d555ba5242032de4747cfe5712ac11584f3bc6de3f5ea.jpeg",
    "https://cdn.faire.com/fastly/5e723b0c3e8530c1ceaf150a35cd6ee8b1eff655023a870ca7775d39bfb5608c.jpeg",
    "https://cdn.faire.com/fastly/de823121fe4b4ea278b07b27c8748ebcbc65d08f3a2a71e6c615e2b09155b17e.jpeg",
    "https://cdn.faire.com/fastly/9acdf704ff258955a698c3217f9893b6e82287053170fe45af9172136cba8218.jpeg",
    "https://cdn.faire.com/fastly/d7eb6e1dff6d537cf767f81d56185f0a8d2824a1b706f4046b08b03a0ad6c22e.png",
  ],
  priceDollars: 40.19,
  description:
    "Meet Aria Houndstooth Lapel Collar Blazer—effortless, flattering, and easy to style for everyday life. This houndstooth blazer is classic and appealing. Designed with a tailored cut that flatters most body shapes. Elegant lapel neckline, double-breasted and faux-wood buttons cuffs. It has two real front pockets with flaps, decorative and functional.\n\nMaterial: 100%Polyester.\n",
  tags: [],
  msrpDollars: 66.99,
  inStock: false,
  meta: {
    source: "api",
    importedAt: "2026-03-25T20:53:23.096Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
